module.exports = __webpack_public_path__ + "static/media/QR_force.b6ebcf3e.png";